/**
 * The what-if model-switch simulator on the Spend view: re-prices one model's
 * real token mix at another model's rates. Shared so the web app and the
 * tests use the same arithmetic.
 */
import { priceTokenUsage } from './settings.js';
/**
 * A target model with no cache rate would charge those tokens as ordinary
 * input, not nothing — e.g. Anthropic cache writes moved to an OpenAI model.
 */
function withCacheFallback(prices) {
    return {
        ...prices,
        cacheReadPerMillion: prices.cacheReadPerMillion ?? prices.inputPerMillion,
        cacheWritePerMillion: prices.cacheWritePerMillion ?? prices.inputPerMillion,
    };
}
/** Assumes the moved work would use the same number of tokens of each type on the target model. */
export function simulateModelSwitch(tokens, from, to, share) {
    const moved = Math.min(1, Math.max(0, share));
    const currentCost = priceTokenUsage(tokens, from);
    const simulatedCost = (1 - moved) * currentCost + moved * priceTokenUsage(tokens, withCacheFallback(to));
    return { currentCost, simulatedCost, saving: currentCost - simulatedCost };
}
//# sourceMappingURL=whatIf.js.map